export default __webpack_public_path__ + "static/cloud-page-banner-4c5a617eb961edc36a47fae53368020c.webm";